
export default "/assets/funnel-mini.57b7cafd.svg"